import { ArrowDropDown, Check } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputBase,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import Loader from '../../common/Loader';

const CustomerSelect = ({
  previouslySelectedCustomers,
  disabled = false,
  inputComponent,
  fullWidth = false,
  requestFunction,
  onSubmit,
}) => {
  const [customers, setCustomers] = useState([]);

  const [loadingCustomers, setLoadingCustomers] = useState(true);
  const [showCustomerDialog, setShowCustomerDialog] = useState(false);
  const [selectedCustomers, setSelectedCustomers] = useState(
    previouslySelectedCustomers
  );
  const [filter, setFilter] = useState('');

  useEffect(() => {
    if (showCustomerDialog) {
      fetchCustomers();
    }
  }, [showCustomerDialog]);

  const filteredCustomers = useMemo(() => {
    return customers
      .filter(({ customer_name, customer_account_no }) => {
        const filterName = customer_name
          .toLowerCase()
          .includes(filter.toLowerCase());
        const filterAccount = customer_account_no
          .toLowerCase()
          .includes(filter.toLowerCase());

        return filterName || filterAccount;
      })
      .map((customer) => {
        const alreadySelected = selectedCustomers?.some(
          (selected) => selected.customer_id === customer.customer_id
        );

        return {
          ...customer,
          isSelected: alreadySelected,
        };
      });
  }, [customers, filter, selectedCustomers]);

  const fetchCustomers = async () => {
    const results = await requestFunction();

    console.log(results);

    setLoadingCustomers(true);
    setCustomers(results);
    setLoadingCustomers(false);
  };

  const handleSelect = (customer) => {
    if (customer.isSelected) {
      if (selectedCustomers.length > 1) {
        setSelectedCustomers(
          selectedCustomers.filter(
            (c) => c.customer_id !== customer.customer_id
          )
        );
      }
    } else {
      console.log('click');
      setSelectedCustomers([...selectedCustomers, customer]);
    }
  };

  let filterTimeout;
  const filterSelectable = (e) => {
    clearTimeout(filterTimeout);
    filterTimeout = setTimeout(() => {
      setFilter(e.target.value);
    }, 500);
  };

  return (
    <>
      {inputComponent ? (
        inputComponent(() => setShowCustomerDialog(true))
      ) : (
        <Stack sx={{ flex: fullWidth ? 1 : 'auto' }}>
          <InputBase
            readOnly
            value={
              previouslySelectedCustomers
                ?.map((el) => el.customer_account_no)
                .join(', ') || ''
            }
            onClick={() => !disabled && setShowCustomerDialog(true)}
            placeholder="Select Customer ..."
            sx={{
              border: '1px solid',
              borderColor: 'grey.400',
              borderRadius: 1.5,
              padding: '8px 8px 8px 12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundColor: 'background.paper',
              '&:hover': {
                borderColor: 'text.primary',
              },
              '&:has(input:focus)': {
                borderWidth: 2,
                borderColor: 'secondary.light',
              },
              '& .MuiInputBase-input': {
                flex: 1,
                cursor: 'pointer',
                padding: 0,
              },
            }}
            endAdornment={<ArrowDropDown sx={{ color: 'grey.600' }} />}
          />
        </Stack>
      )}

      <Dialog
        open={showCustomerDialog}
        maxWidth="lg"
        fullWidth
        onClose={() => setShowCustomerDialog(false)}
      >
        <DialogTitle>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h2">Select Customer</Typography>
            <TextField
              label="Filter Customers"
              onInput={filterSelectable}
              size="small"
            ></TextField>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <TableContainer sx={{ maxHeight: 400, overflow: 'auto' }}>
            <Table stickyHeader sx={{ overflow: 'visible' }}>
              <TableHead>
                <TableRow>
                  <TableCell>Selected</TableCell>
                  <TableCell>Customer Account No</TableCell>
                  <TableCell>Customer Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loadingCustomers && (
                  <TableRow>
                    <TableCell colSpan={7}>
                      <Loader />
                    </TableCell>
                  </TableRow>
                )}
                {!loadingCustomers &&
                  filteredCustomers.map((customer) => (
                    <TableRow
                      key={customer.customer_id}
                      id={`customer-${customer.customer_id}`}
                      hover
                      onClick={() => handleSelect(customer)}
                    >
                      <TableCell>
                        {customer.isSelected && (
                          <Tooltip title="selected">
                            <Check color="success" />
                          </Tooltip>
                        )}
                      </TableCell>
                      <TableCell>{customer.customer_account_no}</TableCell>
                      <TableCell name="name">
                        <Stack direction="row" gap={2} alignItems="center">
                          {customer.customer_name}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              onSubmit(selectedCustomers);
              setShowCustomerDialog(false);
            }}
          >
            Save
          </Button>

          <Button
            variant="text"
            color="secondary"
            onClick={() => setShowCustomerDialog(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CustomerSelect;
